const ROUTES = Object.freeze({
  ACCESS_CODE: 'access-code',
  AGENDA: '/agenda',
  HOME: '/v2/home',
  AGENDA_VISIT_DETAIL: '/agenda/detalhes/data/:dateEpoch/imovel/:houseId',
  AGENDA_VISIT_DETAIL_V2: '/agenda/detalhes/:visitCode',
  AGENT_KEYS: '/minhas-chaves',
  AGENTS_MKT_PATH: '/v2/home',
  BASE_PATH: '/',
  BASE_PATH_VISIT_SCHEDULING: '/?houseid=:houseId&flow=schedule',
  CONFIRM_ACCOUNT_PATH: 'confirm-account',
  CONTACT_US_PATH: '/contact-us',
  CONTRACT_PATH: '/contrato',
  CREATE_ACCOUNT_PATH: 'create-account',
  DOCUMENTATION_PATH: '/documentacao',
  DONE_VISITS_PATH: '/visitas-realizadas',
  ENTRY_INFORMATION_PATH: '/informacoes-de-entrada',
  ENTRY_INFORMATION_RESULT_LIST_PATH: '/informacoes-de-entrada/:houseId',
  FORBIDDEN_PATH: '/forbidden',
  ERROR_PATH: '/error',
  GET_KEYS_PATH: '/minhas-chaves/imovel/:houseId/retirada',
  MY_CLIENTS_GROUPED: '/menu-meus-clientes',
  ONGOING_NEGOTIATION: '/em-negociacao',
  CONVERSATIONS_PATH: '/chats/choose-client',
  CONVERSATIONS_WITH_OWNERS_PATH: '/chats/corretor-proprietario',
  OFFER_PATH: '/negociacao',
  ONLINE_SUPPORT_PATH: '/atendimento-online',

  OFFERS_PATH: '/propostas',
  SALE_OFFER_PATH: '/propostas/:offerId',
  SEARCH_CLIENTS: '/buscar-clientes',
  TIME_BLOCK: '/bloqueio-de-horarios',
  VERIFY_EMAIL_PATH: 'verify-email',
  VISITOR_INFO: '/informacoes-visitante/:visitorId',
  VISIT_SCHEDULED_PATH: '/visitas-agendadas',
  TRAZ_QUEM_COMPRA: '/traz-quem-compra',
  CLIENTS_CRM: '/crm-clientes',
  CLIENT_PROFILE: '/client-profile/:visitorId',
  MY_ACTIVITY: '/minha-atividade',
  REDIRECTING: '/redirecting',
  AMBASSADOR_CONSENT_TERM: '/comunidade/termo-consentimento',
  FAVORITES: '/favoritos',
  SEARCH_PROPERTIES: '/alugar/imovel',
  SHOP_WINDOW: '/favoritos',
  PROFILE: '/meus-dados',
  SALE_HELP: '/atendimento-online?context=sale',
  RENT_HELP: '/atendimento-online?context=rent',
  ARENA_QUINTOANDAR: '/comunidade/termo-consentimento',
  AGENT_SPACE_URL: '/v2/home',
  INDICATE_PROPERTY_PATH: '/v2/indicacao-corretor-com-chaves',
  PORTFOLIO_MANAGER: '/portfolio-manager',
  PORTFOLIO_HOUSE_REGISTRATION: '/house-registration',
  PORTFOLIO_STATUS: '/status',
  PORTFOLIO_MEMBERS: '/members',
});

export default ROUTES;
